import React from 'react';
import { Discount } from '../../../../types/discounts';
import ItemPercent from './itemPercent';
import ItemNewPrice from './itemNewPrice';
import ItemQuantity from './itemQuantity';

interface BadgesProps {
    discount: Discount;
}

enum DiscountType {
    DISCOUNT_AMOUNT = 'discount_amount',
    DISCOUNT_PERCENT = 'discount_percent',
    DISCOUNT_ITEM_NEW_PRICE = 'discount_item_new_price',
    DISCOUNT_ITEM_QUANTITY = 'discount_item_quantity',
    DISCOUNT_ITEM_PERCENT = 'discount_item_percent',
    DISCOUNT_MIX_NEW_PRICE = 'discount_mix_new_price',
    DISCOUNT_DEBIT = 'discount_debit',
}

const renderBadges = (discount: Discount) => {
    const { reward, requirement } = discount;
    switch (reward.type) {
        case DiscountType.DISCOUNT_ITEM_PERCENT:
            return <ItemPercent value={reward.value} />;
        case DiscountType.DISCOUNT_ITEM_NEW_PRICE:
            return <ItemNewPrice
                currencies={requirement.currencies}
                newPrice={reward.value}
            />;
        case DiscountType.DISCOUNT_ITEM_QUANTITY:
            return <ItemQuantity name={discount.name || discount.description || 'N/A'}/>;
        default:
            console.info(`${reward.type} not implemented`);
            return null;
    }
};

const Badges = (
    {
        discount,
    }: BadgesProps
) => {
    return renderBadges(discount);
};

export default Badges;

